// Imported Components from Ant Design
import { theme } from 'antd';

import {ThemeConfig} from 'antd/es/config-provider/context'
// Set the Ant Design theme to darkAlgorithm (Default is light)
const { darkAlgorithm } = theme;

// export const antdTheme = {
//     algorithm: darkAlgorithm,
//     components: {
//         Table: {
//             borderRadius: '0px',
//         },
//         Pagination: {
//             borderRadius: '4px',
//             colorPrimary: '#555859',
//             colorPrimaryHover: '#006b8c',   
//         },
//         Input: {
//             borderRadius: '4px',
//             colorPrimary: '#006b8c',
//             colorPrimaryHover: '#006b8c',
//             colorTextPlaceholder: '#555859'
//         },
//         Button: {
//             borderRadius: '4px',
//             colorPrimary: '#006b8c',
//             colorPrimaryHover: '#006b8c',
//         },
//         Select: {
//             borderRadius: '4px',
//             colorPrimaryHover: '#006b8c',
//             colorTextPlaceholder: '#555859'
//         },
//         Switch: {
//             borderRadius: '4px',
//             colorPrimary: '#006b8c',
//             colorPrimaryHover: '#006b8c',
//         },
//         InputNumber: {
//             borderRadius: '4px',
//             colorPrimaryHover: '#006b8c',
//             colorTextPlaceholder: '#555859',
//             controlWidth: "100%"
//         },
//         DatePicker: {
//             borderRadius: '4px',
//             colorPrimary: '#006b8c',
//             colorPrimaryHover: '#006b8c',
//         },
//         Tour: {
//             colorPrimary: '#006b8c',
//         },
//         Steps: {
//             colorPrimary: '#006b8c',
//         },
//         Checkbox: {
//             colorPrimary: '#006b8c',
//             colorPrimaryHover: '#006b8c',
//         },
//         Tabs: {
//             itemSelectedColor: '#C9C9C9'
//         },
//         Collapse: {
//             contentBg: '#282c30',
//             colorBorder: 'gray',
//         },
//         Slider: {
//             handleActiveColor: '#004459',
//             railBg: 'gray',
//             handleColor: '#006b8c',
//             trackBg: '#006b8c',
//             trackHoverBg: '#006b8c'
//         }     
//     },
// };

export const antdTheme: ThemeConfig = {
  algorithm: darkAlgorithm,
  components: {
    Table: {
      borderRadius: 0, 
      rowSelectedBg: '#003140'
    },
    Pagination: {
      itemActiveBg: '#006b8c',
      itemBg: '#1B1D21',
      borderRadius: 4,
    },
    Input: {
      borderRadius: 4,
      colorPrimary: '#006b8c',
      colorPrimaryHover: '#006b8c',
      colorTextPlaceholder: '#555859',
      colorBgContainer: '#1B1D21',
      colorBorder: '#434343',
      colorText: '#FFFFFF',
      colorTextDisabled: '#8C8C8C',
    },
    Button: {
      borderRadius: 4,
      colorPrimary: '#006b8c',
      colorPrimaryHover: '#006b8c',
    },
    Select: {
      borderRadius: 4,
      colorPrimaryHover: '#006b8c',
      colorTextPlaceholder: '#555859',
      colorBgContainer: '#1B1D21',
      colorBorder: '#434343',
      colorText: '#FFFFFF',
      colorTextDisabled: '#8C8C8C',
    },
    Switch: {
      borderRadius: 4,
      colorPrimary: '#006b8c',
      colorPrimaryHover: '#006b8c',
    },
    InputNumber: {
      borderRadius: 4,
      colorPrimaryHover: '#006b8c',
      colorTextPlaceholder: '#555859',
      colorBgContainer: '#1B1D21',
      colorBorder: '#434343',
      colorText: '#FFFFFF',
      colorTextDisabled: '#8C8C8C',
      // controlWidth is not a supported token; remove or replace
    },
    DatePicker: {
      borderRadius: 4,
      colorPrimary: '#006b8c',
      colorPrimaryHover: '#006b8c',
    },
    Tour: {
      colorPrimary: '#006b8c',
    },
    Steps: {
      colorPrimary: '#006b8c',
    },
    Checkbox: {
      colorPrimary: '#006b8c',
      colorPrimaryHover: '#006b8c',
    },
    Tabs: {
      itemSelectedColor: '#FFF',
      itemActiveColor: '#FFF',
    },
    Collapse: {
      contentBg: '#282c30',
      colorBorder: 'gray',
    },
    Slider: {
      handleActiveColor: '#004459',
      railBg: 'gray',
      handleColor: '#006b8c',
      trackBg: '#006b8c',
      trackHoverBg: '#006b8c',
    },
    Menu: {
      activeBarHeight: 2, // Height of the colored bar at the bottom of the tab-
      horizontalItemSelectedColor: '#006B8C', // Color of the bar at the bottom of the tab-
      horizontalItemSelectedBg: '#1B1D21', // Color of the selected menu item-
    },
    ColorPicker: {
      colorBgContainer: '#1B1D21',
      colorBorder: '#434343',
      colorText: '#FFFFFF',
    },
    Radio: {
      colorPrimary: '#006b8c',
      colorPrimaryHover: '#006b8c',
    },
  },
};